module.exports = __webpack_public_path__ + "img/kitsu-text-dark.4242418d.svg";